module.exports = __webpack_public_path__ + "img/1071fa2.jpg";